module.exports = __webpack_public_path__ + "img/20.16be9b83.jpg";